import React from "react";

export const SuccessIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="52" height="44" viewBox="0 0 52 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.6501 0.5L17.9284 28.8852L7.34986 17.6482L0 25.4556L17.9284 44.5L52 8.30739L44.6501 0.5Z"
        fill="#107C10"
      />
    </svg>
  );
};
